import { accountCreatedRoutine, ACCOUNT_CREATED_CLEANUP } from './routines'

export default {
  [accountCreatedRoutine.TRIGGER](state, payload) {
    state.accountCreated = payload
  },

  [ACCOUNT_CREATED_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
